export default __webpack_public_path__ + "static/media/error-search.ab63aeaf.svg";